const GOOGLE_ADS_PARAMS = ['gad_source', 'gad_campaignid', 'gbraid', 'gclid'];
const UTM_PREFIX = 'utm_';

export function extractGoogleAdsParams(searchParams: URLSearchParams): Record<string, string> {
  const result: Record<string, string> = {};

  for (const [key, value] of searchParams.entries()) {
    const shouldInclude = GOOGLE_ADS_PARAMS.includes(key) || key.startsWith(UTM_PREFIX);

    if (shouldInclude && value && !result[key]) {
      result[key] = decodeURIComponent(value);
    }
  }

  return result;
}

export const GOOGLE_ADS_METADATA_KEY = 'GOOGLE_ADS_METADATA';
